
export abstract class WarehouseSyncAbstractMediaCleanupSteps<T> {
  protected abstract buildFilePaths(dto: T): string[];
}
